import { createApp, defineComponent } from 'vue';
import GridPriorityCellEditor from './GridPriorityCellEditor.vue';
import KeyboardNavigation from '../../keyboardNavigation';

export default function (instance) {
  let vueApp = null;
  let vueInstance = null;

  return {
    show(id, column, config, placeholder) {
      const ComponentBuilder = defineComponent(GridPriorityCellEditor);

      const task = instance.getTask(id);
      const options = instance.ganttDataApi.getColumnByName('priority', task.gantt_id)?.options || [];
      const onSave = () => {
        instance.ext.inlineEditors.save();
      };
      const onCancel = () => {
        instance.ext.inlineEditors.hide();
      };

      if (vueApp) {
        vueApp.unmount();
      }

      vueApp = createApp(ComponentBuilder, {
        placeholder,
        options,
        onSave,
        onCancel,
      });
      vueInstance = vueApp.mount(placeholder);

      KeyboardNavigation.toggleState(false);
    },

    hide() {
      if (vueApp) {
        vueApp.unmount();
      }

      vueApp = null;
      vueInstance = null;

      KeyboardNavigation.toggleState(true);
    },

    set_value(value, id, column, node) {
      vueInstance.value = value;
    },

    get_value(id, column, node) {
      return vueInstance.value;
    },

    is_changed(value, id, column, node) {
      return value !== vueInstance.value;
    },

    is_valid(value, id, column, node) {
      return true;
    },

    save(id, column, node) {
    },

    focus(node) {
    },
  };
}
